function DollarIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#1C274C"
        strokeWidth="1.5"
        className="stroke"
      />
      <path
        d="M12 17V17.5V18"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="stroke"
      />
      <path
        d="M12 6V6.5V7"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="stroke"
      />
      <path
        d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="stroke"
      />
    </svg>
  );
}

export default DollarIcon;
